import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import Gallery from "@/components/site/Gallery";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { brl } from "@/lib/pricing";

const Amenities = ({ chalet }) => {
  const cats = Object.keys(chalet.amenities);
  const [cat, setCat] = useState(cats[0]);
  return (
    <div className="mt-8">
      <div className="flex flex-wrap gap-2">
        {cats.map((c) => (
          <button
            key={c}
            data-testid={`${chalet.id}-amenity-tab-${c}`}
            onClick={() => setCat(c)}
            className={`rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] transition-colors duration-300 ${
              cat === c ? "border-[#163323] bg-[#163323] text-[#faf7f2]" : "border-[#d6d0c4] text-[#163323] hover:border-[#163323]"
            }`}
          >
            {c}
          </button>
        ))}
      </div>
      <ul data-testid={`${chalet.id}-amenity-list`} className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2">
        {chalet.amenities[cat].map((a) => (
          <li key={a} className="flex items-start gap-2.5 text-sm leading-snug text-[#1a241e]">
            <Check className="mt-0.5 h-4 w-4 flex-none text-[#a4532f]" />
            {a}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default function ChaletShowcase({ chalet, reverse, onReserve }) {
  return (
    <article data-testid={`chalet-${chalet.id}`} className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 lg:py-32">
      <div className="grid items-start gap-10 lg:grid-cols-12 lg:gap-16">
        <Reveal className={`min-w-0 lg:col-span-7 ${reverse ? "lg:order-2" : ""}`}>
          <Gallery images={chalet.images} name={chalet.name} testid={`gallery-${chalet.id}`} />
        </Reveal>
        <Reveal delay={0.1} className={`min-w-0 lg:col-span-5 ${reverse ? "lg:order-1" : ""}`}>
          <div className="flex items-baseline gap-4">
            <span className="text-7xl font-bold leading-none tracking-tighter text-[#c86d4b]/25 sm:text-8xl">{chalet.index}</span>
            <Eyebrow>{chalet.tagline}</Eyebrow>
          </div>
          <h2 className="mt-4 text-4xl font-bold uppercase tracking-[-0.03em] text-[#163323] sm:text-5xl">{chalet.name}</h2>
          <p className="mt-5 text-base leading-relaxed text-[#3d4f44] md:text-lg">{chalet.description}</p>
          <Amenities chalet={chalet} />
          <div className="mt-10 flex flex-wrap items-end justify-between gap-6 border-t border-[#e2ded6] pt-6">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#5a6e61]">Diária</p>
              <p data-testid={`${chalet.id}-price`} className="text-3xl font-bold text-[#163323]">{brl(chalet.price)}</p>
            </div>
            <button
              data-testid={`${chalet.id}-reserve-btn`}
              onClick={onReserve}
              className="group flex items-center gap-2 rounded-full bg-[#163323] px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] text-[#faf7f2] transition-colors duration-300 hover:bg-[#a4532f]"
            >
              Reservar {chalet.name}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </button>
          </div>
        </Reveal>
      </div>
    </article>
  );
}
